import api from '@/api'

const SET_MIXERS = 'SET_MIXERS'

const SET_MIXERS_LIST = 'SET_MIXERS_LIST'

const SET_CURRENT_MIXER = 'SET_CURRENT_MIXER'
const UNSET_CURRENT_MIXER = 'UNSET_CURRENT_MIXER'

export default {
  namespaced: true,

  state () {
    return {
      mixers: [],
      mixersList: [],
      currentMixer: null
    }
  },

  getters: {
    mixers: (state) => state.mixers,
    mixersList: (state) => state.mixersList,
    currentMixer: (state) => state.currentMixer
  },

  mutations: {
    [SET_MIXERS] (state, data) {
      state.mixers = data
    },

    [SET_MIXERS_LIST] (state, data) {
      state.mixersList = data
    },

    [SET_CURRENT_MIXER] (state, data) {
      state.currentMixer = data
    },

    [UNSET_CURRENT_MIXER] (state) {
      state.currentMixer = null
    }
  },

  actions: {
    async loadMixers ({ commit }, params = {}) {
      const filters = {}
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data } = await api.mixers.list(filters)
      commit(SET_MIXERS, data || [])
      return data
    },

    async loadMixersList ({ commit }, params = {}) {
      const filters = {}
      for (const key in params) {
        filters[key] = params[key]
      }
      filters.deleted = false
      const { data } = await api.mixers.litelist(filters)
      commit(SET_MIXERS_LIST, data || [])
      return data
    },

    async createMixer ({ dispatch }, payload) {
      const filters = { farm: payload.farm }
      dispatch('loadMixers', filters)
    },

    async openMixerDetail ({ commit }, id) {
      const { data } = await api.mixers.getById(id)
      commit(SET_CURRENT_MIXER, data)
    },

    async saveChanges ({ commit, dispatch, getters }) {
      const item = getters.currentMixer
      const params = { farm: item.farm }
      dispatch('loadMixers', params)
      commit(UNSET_CURRENT_MIXER)
    },

    async deleteMixer ({ commit, dispatch, getters }) {
      const item = getters.currentMixer
      await api.mixers.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadMixers', params)
      commit(UNSET_CURRENT_MIXER)
    },

    closeMixerDetail ({ commit }) {
      commit(UNSET_CURRENT_MIXER)
    }
  }
}
